import * as React from "react";

const WarningHarmful: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="none"
        >
            <path
                className="icon-background"
                d="m 11.999593,2.8315191 c -0.586066,0 -1.124106,0.3030334 -1.42173,0.8090362 L 1.7193292,18.716145 c -0.2976432,0.507303 -0.2899418,1.136339 0.00845,1.643257 0.3397077,0.576885 0.9351769,0.810529 1.5227812,0.809058 H 20.749374 c 0.587796,0.0026 1.183044,-0.232139 1.522781,-0.809058 0.298393,-0.506918 0.306282,-1.135954 0.0084,-1.643257 L 13.422072,3.6405553 C 13.124429,3.1345525 12.586215,2.8315191 12.000341,2.8315191 Z"
                fill="transparent"
                fillRule="nonzero"
                stroke="none"
            />
            <path
                d="m 11.999593,2.8315191 c -0.586066,0 -1.124106,0.3030334 -1.42173,0.8090362 L 1.7193292,18.716145 c -0.2976432,0.507303 -0.2899418,1.136339 0.00845,1.643257 0.3397077,0.576885 0.9351769,0.810529 1.5227812,0.809058 H 20.749374 c 0.587796,0.0026 1.183044,-0.232139 1.522781,-0.809058 0.298393,-0.506918 0.306282,-1.135954 0.0084,-1.643257 L 13.422072,3.6405553 C 13.124429,3.1345525 12.586215,2.8315191 12.000341,2.8315191 Z m -0.04236,1.0282396 c 0.187512,0 0.407375,0.1259608 0.497078,0.2782774 l 8.864046,15.0899449 c 0.08971,0.152697 0.08991,0.395577 0,0.548274 -0.04872,0.08265 -0.410952,0.278846 -0.598287,0.278279 H 3.1942145 c -0.1875123,0 -0.5495609,-0.195627 -0.5982868,-0.278279 -0.089902,-0.152697 -0.089714,-0.395577 0,-0.548274 L 11.45997,4.1380361 c 0.08971,-0.1525094 0.309764,-0.2782774 0.497079,-0.2782774 z m 0.04254,4.8841384 c -0.591656,0 -1.071209,0.4848264 -1.071209,1.0829901 l 0.26791,4.8738918 c 0,0.448576 0.359814,0.812363 0.803526,0.812363 0.443712,0 0.803527,-0.363772 0.803527,-0.812363 l 0.267902,-4.8738918 c 0,-0.5981637 -0.479552,-1.0829901 -1.071209,-1.0829901 z M 12,16.027262 c -0.733798,0 -1.328571,0.594581 -1.328571,1.328143 0,0.733562 0.594773,1.328142 1.328571,1.328142 0.733799,0 1.328572,-0.59458 1.328572,-1.328142 0,-0.733562 -0.594773,-1.328143 -1.328572,-1.328143 z"
                fill="currentColor"
                fillRule="nonzero"
                stroke="none"
            />
            <path
                d="m 12.000079,5.2465769 c 0.15634,0 0.339651,0.1050545 0.414443,0.2320902 l 7.390445,12.5853889 c 0.0748,0.127354 0.07496,0.329921 0,0.457275 -0.04061,0.06893 -0.342634,0.232564 -0.498824,0.232091 H 4.6938559 c -0.1563394,0 -0.4581995,-0.163156 -0.4988249,-0.232091 -0.074956,-0.127354 -0.0748,-0.329921 0,-0.457275 L 11.585476,5.4786671 c 0.0748,-0.1271966 0.258267,-0.2320902 0.414443,-0.2320902 z"
                fill="none"
                fillRule="evenodd"
                stroke="none"
            />
        </svg>
    );
};

export default React.memo(WarningHarmful);
